import { render, staticRenderFns } from "./BotoesNavegacao.vue?vue&type=template&id=56fdf0d0&scoped=true"
import script from "./BotoesNavegacao.vue?vue&type=script&lang=js"
export * from "./BotoesNavegacao.vue?vue&type=script&lang=js"
import style0 from "./BotoesNavegacao.vue?vue&type=style&index=0&id=56fdf0d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fdf0d0",
  null
  
)

export default component.exports